import type { CardUrl, CardUrlType, FieldTypes } from 'types';

/**
 * Formats the type of a URL to proper spelling.
 * @param type Type of the URL field
 */
export function formatUrlType(type: CardUrl['type']): string {
  switch (type) {
    case 'calendly':
      return 'Calendly';
    case 'discord':
      return 'Discord';
    case 'facebook':
      return 'Facebook';
    case 'github':
      return 'GitHub';
    case 'instagram':
      return 'Instagram';
    case 'threads':
      return 'Threads';
    case 'linkedin':
      return 'LinkedIn';
    case 'org':
      return 'Company URL';
    case 'paypal':
      return 'PayPal';
    case 'skype':
      return 'Skype';
    case 'snapchat':
      return 'Snapchat';
    case 'telegram':
      return 'Telegram';
    case 'tiktok':
      return 'TikTok';
    case 'twitch':
      return 'Twitch';
    case 'twitter':
    case 'twitterX':
      return 'X';
    case 'venmo':
      return 'Venmo';
    case 'cashapp':
      return 'CashApp';
    case 'wechat':
      return 'WeChat';
    case 'whatsapp':
      return 'WhatsApp';
    case 'yelp':
      return 'Yelp';
    case 'youtube':
      return 'YouTube';
    case 'signal':
      return 'Signal';
    default:
      return 'Link';
  }
}

/**
 * Render the label
 * @param fieldType
 */
export function formatFieldType(fieldType: Exclude<FieldTypes, 'url'>): string;
export function formatFieldType(fieldType: 'url', fieldSubType: CardUrlType): string;
export function formatFieldType(fieldType: FieldTypes, fieldSubType?: CardUrlType): string {
  switch (fieldType) {
    case 'name':
      return 'Name';
    case 'accreditations':
      // Could also be <i class="far fa-user-graduate"></i>
      return 'Accreditations';
    case 'org_name':
      return 'Company name';
    case 'department':
      return 'Department';
    case 'job_title':
      return 'Job title';
    case 'headline':
      return 'Headline';
    case 'url':
      if (!fieldSubType) throw new Error('Field sub type not provided');
      return formatUrlType(fieldSubType);
    case 'phone':
      return 'Phone';
    case 'address':
      return 'Address';
    case 'email':
      return 'Email';
  }
}
